var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligiblityFJdL2Uf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.422,
    height: 57.417,
    viewBox: "0 0 50.422 57.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.946,19.764a9.882,9.882,0,1,0-9.882-9.882A9.893,9.893,0,0,0,100.946,19.764Z",
    transform: "translate(-53.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.829,185.911a12.311,12.311,0,0,0-9.735-8.529l-4.662,6.637v14.543H46.061V184.019L41.4,177.382A12.292,12.292,0,0,0,31.13,189.49v21.693H54.912a16.482,16.482,0,0,1,8.917-25.273Zm-21.65,6.308H38.445v-3.733h3.733Z",
    transform: "translate(0 -157.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.461,277.47a13.122,13.122,0,1,0,13.122,13.122A13.073,13.073,0,0,0,259.461,277.47Zm-1.4,18.722-2.667-2.667-2.154-2.154,2.154-2.154.229-.229,2.438,2.438,5.242-5.241,2.383,2.383Z",
    transform: "translate(-191.03 -246.296)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligiblityFJdL2Uf);
export default __webpack_public_path__ + "static/media/eligiblity_fJdL2uf.10114becb37ac738242bd59c58634378.svg";
export { ForwardRef as ReactComponent };